exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-toolbar__content{padding-left:2px!important}", ""]);

// exports
